module.exports = __webpack_public_path__ + "img/logo.1f5da3a7.svg";